<template>
    <div
        class="h:margin-right-6"
        :class="['icon-button', 'icon-button--toggleFilter', {'icon-button--toggle-active': status}, {'icon-button--toggle-inactive': !status}]"
        @click="toggle"
        :title="trans('search.filter_your_search')"
    >
        <div class="icon-button__icon">
            <!-- Inline svg class or img tag does not work on IE11 -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.60004 24C9.53119 24 9.46234 23.9824 9.40082 23.9467C9.27649 23.8751 9.19995 23.7433 9.19995 23.5999V14.5516L0.100342 4.26471C0.0355224 4.19165 0 4.09753 0 3.99994V0.400085C0 0.178711 0.17926 0 0.400085 0H23.5999C23.8207 0 24 0.178711 24 0.400085V3.99994C24 4.09753 23.9645 4.19165 23.8997 4.26471L14.8 14.5516V20.8C14.8 20.942 14.7244 21.074 14.6016 21.1456L9.80164 23.9456C9.7392 23.9817 9.66962 24 9.60004 24ZM1.99999 3.84833L10.8 13.2C10.8 13.2 11.1999 14.2185 11.1999 14.4V20.5036L12.8001 19.3704V14.4C12.8001 14.2576 13.8 13.2 13.8 13.2L22 3.84833V1.99999H1.99999V3.84833Z" />
                <path d="M10.3827 4.8H1.61743C1.38701 4.8 1.19995 4.53166 1.19995 4.19986C1.19995 3.86807 1.38701 3.6 1.61743 3.6H10.3827C10.6131 3.6 10.8 3.86807 10.8 4.19986C10.8 4.53166 10.6131 4.8 10.3827 4.8Z" />
                <path d="M14.0571 14.4H12.3429C12.1536 14.4 12 14.1317 12 13.7999C12 13.4681 12.1536 13.2 12.3429 13.2H14.0571C14.2464 13.2 14.4 13.4681 14.4 13.7999C14.4 14.1317 14.2464 14.4 14.0571 14.4Z" />
                <path d="M22.4 4.8H18.4C18.1792 4.8 18.0001 4.53166 18.0001 4.19986C18.0001 3.86807 18.1792 3.6 18.4 3.6H22.4C22.6209 3.6 22.8001 3.86807 22.8001 4.19986C22.8001 4.53166 22.6209 4.8 22.4 4.8Z" />
                <path d="M15.0858 4.8H12.5142C12.2303 4.8 12 4.53166 12 4.19986C12 3.86807 12.2303 3.6 12.5142 3.6H15.0858C15.3697 3.6 15.6 3.86807 15.6 4.19986C15.6 4.53166 15.3697 4.8 15.0858 4.8Z" />
            </svg>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            status: false
        };
    },

    methods: {
        toggle() {
            this.status = !this.status;
            EventBus.$emit('toggleFilter', this.status);
        }
    },
};
</script>
